import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Vue from 'vue';
import zenscroll from 'zenscroll';
import { checkCCM19Consent, checkOneTrustConsent } from '../utils';

gsap.registerPlugin(ScrollTrigger);

Vue.component('section-chapter', {
    data() {
        return {
            chapterOpen: false,
            scrollToElement: null,
        };
    },

    computed: {
        toggleChapterClass() {
            return this.chapterOpen ? 'section-chapter--open' : '';
        },

        toggleModelSpecsClass() {
            return this.chapterOpen
                ? 'section-chapter--open model-new-section-chapter--custom-spacing'
                : '';
        },
    },

    mounted() {
        EventBus.$on('closeSpecs', () => {
            this.chapterOpen = false;
        });
    },

    methods: {
        toggleSeeFullSpecs(e) {
            e.preventDefault();

            this.chapterOpen = !this.chapterOpen;
            EventBus.$emit('openSpecs');

            // reset scrolltrigger when section opens/closes
            ScrollTrigger.refresh();

            if (this.chapterOpen) {
                gsap.fromTo(
                    this.$el.querySelector('.section-chapter'),
                    { height: 0 },
                    { height: 'auto', duration: 0.6 },
                );
                this.scrollToElement = e.currentTarget;
                zenscroll.to(this.$el.querySelector('.section-chapter'));

                // datalayer
                if (this.$root.handle == 'mgMotorsFrance') {
                    dataLayer.push({
                        event: 'contentClic',
                        eventCategory: 'Showroom Content',
                        eventAction: e.currentTarget.dataset.section,
                        eventLabel: e.currentTarget.dataset.model,
                    });
                }
            } else {
                gsap.fromTo(
                    this.$el.querySelector('.section-chapter'),
                    { height: 'auto' },
                    { height: 0, duration: 0.6, delay: 0.4 },
                );
                zenscroll.to(this.$el, 700);
                if (checkCCM19Consent() || checkOneTrustConsent()) {
                    // check if you are on production-enviroment
                    if (this.$root.handle == 'mgMotorsFrance') {
                        gtag('event', 'conversion', {
                            allow_custom_scripts: true,
                            send_to: 'DC-10256326/mg-autos/fr_in002+unique',
                        }); //french
                    }

                    if (this.$root.handle == 'mgMotorsNorway') {
                        gtag('event', 'conversion', {
                            allow_custom_scripts: true,
                            send_to: 'DC-10210913/retar0/no_re001+standard',
                        }); //norway
                    }
                }
            }
        },

        toggleChapter(e) {
            e.preventDefault();

            this.chapterOpen = !this.chapterOpen;

            // reset scrolltrigger when section opens/closes
            ScrollTrigger.refresh();

            if (this.chapterOpen) {
                gsap.fromTo(
                    this.$el.querySelector('.section-chapter'),
                    { height: 0 },
                    { height: 'auto', duration: 0.6 },
                );
                this.scrollToElement = e.currentTarget;
                zenscroll.to(this.$el.querySelector('.section-chapter'));

                // datalayer
                if (this.$root.handle == 'mgMotorsFrance') {
                    dataLayer.push({
                        event: 'contentClic',
                        eventCategory: 'Showroom Content',
                        eventAction: e.currentTarget.dataset.section,
                        eventLabel: e.currentTarget.dataset.model,
                    });
                }
            } else {
                gsap.fromTo(
                    this.$el.querySelector('.section-chapter'),
                    { height: 'auto' },
                    { height: 0, duration: 0.6, delay: 0.4 },
                );
                zenscroll.to(this.$el, 700);
                if (checkCCM19Consent() || checkOneTrustConsent()) {
                    // check if you are on production-enviroment
                    if (this.$root.handle == 'mgMotorsFrance') {
                        gtag('event', 'conversion', {
                            allow_custom_scripts: true,
                            send_to: 'DC-10256326/mg-autos/fr_in002+unique',
                        }); //french
                    }

                    if (this.$root.handle == 'mgMotorsNorway') {
                        gtag('event', 'conversion', {
                            allow_custom_scripts: true,
                            send_to: 'DC-10210913/retar0/no_re001+standard',
                        }); //norway
                    }
                }
            }
        },
    },
});
